module.exports = __webpack_public_path__ + "img/chevron-right.47ec89ad.svg";